import { initializeApollo } from 'gql/client'
import { NextWrapper } from 'data-fetching-wrapper'
import BlogDetailTemplate from '@components/templates/BlogDetailTemplate/BlogDetailTemplate'
import { NewsBySlugDocument, NewsEmakInformaBySlugDocument } from '@gql/graphql'

const ProdottoDetail = ({ pagina, news, mainContent }) => {
  return (
    <BlogDetailTemplate
      pagina={pagina}
      news={news}
      mainContent={mainContent}
      showNewsletterBox={false}
    />
  )
}

export const getStaticPaths = NextWrapper.getStaticPaths(
  async () => ({
    paths: [],
    fallback: 'blocking',
  }),
  '/emak-informa/[slug]'
)

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { slug }, preview, previewData, locale }) => {
    const client = initializeApollo(locale)
    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}
    const {
      data: { newsEmakInformaBySlug },
    } = await client.query({
      query: NewsEmakInformaBySlugDocument,
      variables: { slug, preview },
      context: {
        headers,
      },
    })

    if (!newsEmakInformaBySlug) {
      return {
        notFound: true,
      }
    }

    return {
      props: {
        pagina: newsEmakInformaBySlug.pagina,
        news: newsEmakInformaBySlug,
        mainContent:
          newsEmakInformaBySlug?.pagebuilders?.find((x) => x.key === 'news_content') ?? null,
      },
      revalidate: 60 * 20,
    }
  },
  '/emak-informa/[slug]'
)

export default ProdottoDetail
